import React from "react";

const AddDeliveryPartner = () => {
  return <div>AddDeliveryPartner</div>;
};

export default AddDeliveryPartner;
